import { useState } from "react";
import { useAsync } from "react-use";
import { useSWRConfig } from "swr";
import { Box, Title, Group, Stack } from "@mantine/core";
import { getChannels, syncPlaylistsVk, syncPlaylistsYoutube, useFetch, PLATFORM_VK, PLATFORM_YOUTUBE } from "../../shared/api";
import { isAdmin } from "../../shared/AuthContext";
import { ChannelDetail } from "../../shared/components/ChannelDetail";
import { usePageTitle } from "../../shared/utils";
import youtubeIcon from "../../shared/assets/colored/youtube.png";
import vkIcon from "../../shared/assets/colored/vk.png";

const PLATFORMS = [
  { key: PLATFORM_VK, title: "VK", icon: vkIcon, sync: syncPlaylistsVk },
  { key: PLATFORM_YOUTUBE, title: "YouTube", icon: youtubeIcon, sync: syncPlaylistsYoutube },
] as const;

export function Playlists() {
  usePageTitle("Плейлисты");
  const { fetch } = useFetch();
  const [nonce, setNonce] = useState(0);
  const { value: channels } = useAsync(() => getChannels({ fetch }), [nonce]);
  const { value: isAdminValue } = isAdmin();
  const { mutate } = useSWRConfig();
  const refresh = () => { setNonce(n => n + 1); mutate("admin/subjects"); mutate("playlists/channels"); };

  return (
    <Box component="main" p="xl">
      <Box maw={1100} mx="auto" px="xs">
        <Title order={2} mb="lg">Плейлисты</Title>
        <Stack gap="xl">
          {PLATFORMS.map(({ key, title, icon, sync }) => (
            <Box key={key}>
              <Group gap="md" align="center" mb="lg">
                <img src={icon} alt={title} style={{ height: "auto", width: 28 }} />
                <Title order={3} fz={24}>{title}</Title>
              </Group>
              {channels && (
                <Stack gap="md">
                  {channels[key].map(ch => (
                    <ChannelDetail
                      key={ch.id} channel={ch} platform={key}
                      onSync={isAdminValue ? async () => { await sync({ channelId: ch.id, fetch }); refresh(); } : undefined}
                      onChanged={refresh}
                    />
                  ))}
                </Stack>
              )}
            </Box>
          ))}
        </Stack>
      </Box>
    </Box>
  );
}
